import { AppStateType } from "Redux/ReduxStore"

export const getProjectsSelector = (state: AppStateType) => {
  return state.ProjectsReducer.projects
}

export const getProjectInfoSelector = (state: AppStateType) => {
  return state.ProjectsReducer.projectInfo
}

export const getProjectLoadingStateSelector = (state: AppStateType) => {
  return state.ProjectsReducer.isLoading
}
